/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'source-maps',
  title: 'Upload source maps',
  category: 'Error tracking',
  summary:
    'Turn minified Angular stack traces into your original TypeScript by uploading source maps for each release from CI.',
  keywords: ['source maps', 'sourcemaps', 'minified', 'stack trace', 'Angular', 'CI', 'release', 'upload token'],
};

export const loadComponent = () => import('./source-maps.component').then((m) => m.SourceMapsArticleComponent);
